import { Component, computed, inject, input, output } from '@angular/core';
import { ButtonDirective } from '@innersource/common-ui-components';
import { formatDateTime } from '../../utils/helper';
import { ChatSession } from '../chat.model';
import { ChatConversationService } from '../chat-conversation.service';
import { sortSessionsByModified } from '../chat.util';

/** Shows saved conversations in a sidebar or the chat overview. */
@Component({
  selector: 'app-chat-session-history',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './chat-session-history.component.html',
  styleUrl: './chat-session-history.component.scss',
  host: {
    '[class.chat-session-history--sidebar]': 'layout() === "sidebar"',
  },
})
export class ChatSessionHistoryComponent {
  /** Inputs. */
  readonly layout = input<'sidebar' | 'overview'>('overview');

  /** Outputs. */
  readonly newChat = output<void>();
  readonly selectSession = output<ChatSession>();

  /** Services. */
  readonly conversation = inject(ChatConversationService);

  /** Template Forwards. */
  readonly formatDateTime = formatDateTime;

  /** The displayed sessions, most recently modified first. */
  readonly visibleSessions = computed(() => {
    const sessions = this.conversation.sessions();
    const active = this.conversation.activeSession();
    if (!active || sessions.some(session => session.id === active.id)) return sessions;
    return [active, ...sessions].sort(sortSessionsByModified);
  });
}
